export function getRegisterId(): string {
  return window.merchantos.session.getRegister()?.registerID ?? '';
}

export function getLocationId(): string {
  return window.merchantos.session.getShop()?.shopID ?? '';
}
